import { 
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {
	envAwarePost,
	envAwareFormSubmit
} from '../util/util'

export const getPortionUnits = createAsyncThunk(
	'foods/getPortionUnits',
	async ()=> await envAwarePost(
		'api/foods/',
		{action:'getPortionUnits'}
	)
)

//LEGACY DO NOT USE
export const getFoodLibrary = createAsyncThunk(
	'getFoodLibrary',
	async ()=> await envAwarePost('exerFoodListAddEditDeleteMobWeb/',{
		operation:'list',
		selector:'food'
	})
)

export const getLibraryFoods = createAsyncThunk(
	'getFoodLibrary',
	async tgt_user_id_number => await envAwarePost('api/foods/api/',{
		action:'getLibraryFoods',
		tgt_user_id_number
	})
)

export const getFoods = createAsyncThunk(
	'getFoods',
	async (payload,{signal}) =>{ 
		if(signal.aborted) throw new Error('Aborted')
		return await envAwarePost('api/foods/',{
			action:'getFoods',
			...payload
		})
	}
)

export const searchFoods = createAsyncThunk(
	'searchFoods',
	async (payload,{signal}) => {
		if(signal.aborted) throw new Error('Aborted')
		return await envAwarePost('api/foods/',{
			action:'searchFoods',
			...payload
		})
	}
)

export const deleteFood = createAsyncThunk(
	'deleteFood',
	async payload => await envAwarePost("exerFoodListAddEditDeleteMobWeb.php",payload)
)

export const createFood = createAsyncThunk(
	'createFood',
	async payload => {
		return await envAwarePost('api/foods/',{
			action:'createFood',
			data:payload
		})
	}
)

export const updateFood = createAsyncThunk(
	'updateFood',
	async payload => await envAwarePost('api/foods/',{
		action:'editFood',
		...payload
	})
)

const adapter = createEntityAdapter({
	selectId:ent=>ent.food_db_id
})

const slice = createSlice({
	name: 'foods',
	initialState:adapter.getInitialState({
		query:'',
		status:'init',
		tgtUser:null,
		portionUnits:[]
	}),
	reducers: {},
	extraReducers:{
		[getPortionUnits.fulfilled] : (state,action)=>{
			state.portionUnits = action.payload.data.portion_units
		},
		[createFood.fulfilled] : (state,action)=>{
			const {food} = action.payload.data
			adapter.upsertOne(state,food)
		},
		[updateFood.fulfilled] : (state,action)=>{
			const {food} = action.payload.data
			adapter.upsertOne(state,food)
		},
		[deleteFood.pending] : (state,action) => {
			const {item_db_id} = action.meta.arg
			adapter.removeOne(state,item_db_id)
		}, 
		[getLibraryFoods.pending] : (state,action) => { 
			state.status = 'pending' 
			state.tgtUser = action.meta.arg
		},
		[getLibraryFoods.fulfilled] : (state,action) => {
			state.status = 'idle'
			const {data:{foods}} = action.payload
			adapter.upsertMany(state,foods)
		},
		[getFoods.pending] : (state,action) => { 
			state.status = 'pending' 
			const {clearFoods} = action.meta.arg
			if(clearFoods) adapter.setAll(state,[])
			state.tgtUser = action.meta.arg
		},
		[getFoods.fulfilled] : (state,action) => {
			const {append} = action.meta.arg
			state.status = 'idle'
			const {data:{foods}} = action.payload
			if(append){
				adapter.upsertMany(state,foods)
			} else {
				adapter.setAll(state,foods)
			}
		},
		[searchFoods.pending] : (state,action) => { 
			const {clearFoods} = action.meta.arg
			if(clearFoods) adapter.setAll(state,[])
			state.status = 'pending' 
		},
		[searchFoods.fulfilled] : (state,action) => {
			const {append} = action.meta.arg
			state.status = 'idle'
			const {data:{foods}} = action.payload
			if(append){
				adapter.upsertMany(state,foods)
			} else {
				adapter.setAll(state,foods)
			}
		}
	}
})

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllFoods,
	selectById: selectFoodById,
	selectIds: selectFoodsIds
} = adapter.getSelectors(state => state.foodLibrary)

export const selectLibrary = state => state.foodLibrary

export default slice.reducer